import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface StagedFile {
  id: string;
  original_name: string;
  metadata: {
    google_drive_id: string;
    google_drive_name: string;
    google_drive_mime_type: string;
    google_drive_size: number;
    google_drive_web_view_link?: string;
    shared_by_email: string;
    shared_at: string;
    is_multi_location_user: boolean;
    sharing_context: {
      user_id: string;
      location_id: number | null;
      shared_by_email: string;
      shared_at: string;
      requires_location_assignment: boolean;
      has_folder_structure?: boolean;
      suggested_folder_path?: string;
    };
    local_folder_path?: string;
  };
  created_at: Date;
  file_size: number;
  mime_type: string;
  folder_structure?: {
    folder_path: string;
  };
}

export type ApiResponse_GetStagedFiles = {
  success: boolean;
  staged_files: StagedFile[];
};

const METHOD = 'GET';
const ENDPOINT = 'document/google-drive/staged-files';
const QUERY_KEY = getQueryKey(METHOD, ENDPOINT);

export const useGetStagedFiles = (enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: QUERY_KEY,
    enabled: enabled && !!session?.access_token,
    queryFn: async () => {
      const response = await handleApiCall<ApiResponse_GetStagedFiles>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {})
      );

      return response.staged_files;
    },
  });
};
